const baseUrl =
  process.env.MIX_ENV === 'prod'
    ? 'https://sybridgetech.lightning.force.com'
    : 'https://test.salesforce.com';

export const getOpportunityUrl = opportunityId =>
  `${baseUrl}/lightning/r/Opportunity/${opportunityId}/view`;
